/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["library-tracks{display:block;width:100%;height:100%;flex:1 1 auto;min-width:0}library-tracks>.scroll-container{padding:20px}library-tracks filterable-page-header{margin-bottom:15px}library-tracks no-results-message{margin-top:25px}"];
export { styles as styles };
